import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Cidade } from '../page/cidade/cidade';

@Injectable({
  providedIn: 'root'
})
export class CidadeService {

  apiURL: string = environment.apiBaseUrl + 'cidade';

  private readonly apiUrlBrasilapi = 'https://brasilapi.com.br/api/ibge/municipios/v1';

  constructor(private http: HttpClient) { }

  buscarCidade(page: number, parametroConsulta: string) {
    const params = new HttpParams().set('page', page.toString());
    return this.http.get<any>(`${this.apiURL}/${parametroConsulta}?${params.toString()}`);
  }

  salvar(cidade: Cidade): Observable<Cidade> {
    return this.http.post<Cidade>(this.apiURL, cidade);
  }

  alterar(cidade: Cidade): Observable<any> {
    return this.http.put<Cidade>(`${this.apiURL}/${cidade.id}`, cidade);
  }

  buscarMunicipios(uf: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrlBrasilapi}/${uf}`);
  }

}